import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faMessagesQuestion } from '@fortawesome/pro-light-svg-icons';
import QuestionSection from './QuestionSection';
import { GroupedQuestion } from './IFAQAllQuestionPage';

const AllQuestion: React.FC<GroupedQuestion> = ({ categories }) => (
  <>
    <div className="flex items-center gap-2 h-10 ml-[10px] md:ml-0 mb-[16px] md:mb-[24px]">
      <FontAwesomeIcon
        icon={faMessagesQuestion as IconProp}
        className="text-blue-500 text-3xl"
      />
      <h1 className="font-bold font-avantgarde text-xl sm:text-2xl lg:text-3xl xl:text-4xl text-blue-900">
        Veelgestelde vragen
      </h1>
    </div>
    <p className="text-stone-800">
      Op deze pagina vind je antwoord op veel gestelde vragen over diverse
      onderwerpen van Advieskeuze. Staat je vraag er niet bij? Stel hem via
      het{' '}
      <span className="cursor-pointer underline text-blue-500 font-medium">
        <a href={`/home/contact`}>contactformulier</a>
      </span>
      , je krijgt dan zo snel mogelijk een reactie van ons!
    </p>
    {categories?.map(({ name, questions } ) => (
      <div key={name}>
        <hr className="my-8 md:my-10 border-top-2 border-stone-100" />
        <QuestionSection
          name={name}
          questions={questions}
        />
      </div>
    ))}
  </>
);

export default AllQuestion;
